<template>
    <v-toolbar flat dense class="pagination-toolbar" style="border-top: 1px solid rgba(0, 0, 0, 0.12);">
        <v-spacer></v-spacer>
        <span class="mr-4 body-2">Số dòng/trang:</span>
        <v-select
            v-model="internalPagination.itemsPerPage"
            :items="itemsPerPageOptions"
            style="max-width: 80px"
            dense
            hide-details
            class="mr-4"
        ></v-select>
        <span class="mr-4 body-2">Trang {{ internalPagination.page }}</span>
        <v-btn icon :disabled="!hasPrevPage" @click="prevPage">
            <v-icon>fa-chevron-left</v-icon>
        </v-btn>
        <v-btn icon :disabled="!hasNextPage" @click="nextPage">
            <v-icon>fa-chevron-right</v-icon>
        </v-btn>
    </v-toolbar>
</template>

<script>
export default {
    name: 'CursorPagination',
    props: {
        pagination: {
            type: Object,
            required: true
        },
        hasNextPage: {
            type: Boolean,
            required: true
        },
        itemsPerPageOptions: {
            type: Array,
            default: () => [20, 30, 40, 50, 100, 200, 500]
        }
    },
    computed: {
        internalPagination: {
            get() {
                return this.pagination;
            },
            set(val) {
                this.$emit('update:pagination', val);
            }
        },
        hasPrevPage() {
            return this.internalPagination && this.internalPagination.page > 1;
        }
    },
    methods: {
        prevPage() {
            if (this.hasPrevPage) {
                this.internalPagination.page--;
            }
        },
        nextPage() {
            if (this.hasNextPage) {
                this.internalPagination.page++;
            }
        }
    }
}
</script>
